import type { Route } from 'next';

import type { SocialMediaAccountService } from '#types/global';

type GetSocialMediaUrlInput = {
	accountName?: string | null;
	service?: SocialMediaAccountService | null;
};

/**
 * Generates the URL for a social media account based on the provided input.
 *
 * @param input The input object containing the account name and service.
 * @param withoutEmail Optional flag to exclude email URLs.
 * @return The URL for the social media account, or null if the service is Email and withoutEmail is true or accountName is falsy.
 */
export function getSocialMediaUrl(input: GetSocialMediaUrlInput, withoutEmail = false) {
	const { accountName, service } = input;
	if (service === 'EMAIL' && (withoutEmail || !accountName)) {
		return null;
	}
	if (service === 'EMAIL') {
		return `mailto:${accountName}` as const;
	}
	return accountName as Route;
}
